import { Icon } from "@zapier/design-system";
import { Tooltip } from "@zapier/design-system-beta";
import styles from "./FloatingClearSelectionButton.module.css";

type Props = {
  clearSelection: () => void;
};

export const FloatingClearSelectionButton = ({ clearSelection }: Props) => {
  return (
    <Tooltip placement="left" content="Clear selection">
      <Tooltip.FocusableTrigger>
        <button
          type="button"
          className={styles.floatingClearSelectionButton}
          onClick={clearSelection}
          title="Clear selection"
        >
          <Icon name="formXCircle" color="GrayWarm6" size="24px" />
        </button>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
};
